(() => {
  const ROOT = '[data-net-reference-header]';
  const OPEN_DELAY = 0;
  const CLOSE_DELAY = 200;

  function initMenu(header) {
    const nav = header.querySelector('[data-net-nav]');
    const mega = header.querySelector('[data-net-mega]');
    const megaToggle = header.querySelector('[data-net-mega-toggle]');
    if (!nav || !mega || !megaToggle || nav.dataset.netMenuInit === 'true') return;
    nav.dataset.netMenuInit = 'true';

    let closeTimer = 0;
    let openTimer = 0;
    const items = [...nav.querySelectorAll('[data-net-nav-item]')];

    function clearTimers() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
    }

    function hideMega() {
      mega.hidden = true;
      megaToggle.setAttribute('aria-expanded', 'false');
    }

    function closeItems(except = null) {
      items.forEach(item => {
        if (item === except) return;
        const button = item.querySelector('[data-net-nav-button]');
        const dropdown = item.querySelector('[data-net-nav-dropdown]');
        button?.setAttribute('aria-expanded', 'false');
        if (dropdown) dropdown.hidden = true;
      });
    }

    function positionDropdown(item) {
      const button = item.querySelector('[data-net-nav-button]');
      const dropdown = item.querySelector('[data-net-nav-dropdown]');
      if (!button || !dropdown) return;
      const rect = button.getBoundingClientRect();
      dropdown.style.top = `${Math.round(rect.bottom)}px`;
      dropdown.style.left = `${Math.max(0, Math.min(rect.left, window.innerWidth - dropdown.offsetWidth - 8))}px`;
    }

    function openItem(item) {
      clearTimers();
      hideMega();
      closeItems(item);
      const button = item.querySelector('[data-net-nav-button]');
      const dropdown = item.querySelector('[data-net-nav-dropdown]');
      if (!button || !dropdown) return;
      dropdown.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => positionDropdown(item));
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        hideMega();
        closeItems();
      }, CLOSE_DELAY);
    }

    megaToggle.addEventListener('pointerenter', () => {
      clearTimers();
      closeItems();
      openTimer = window.setTimeout(() => {
        mega.hidden = false;
        megaToggle.setAttribute('aria-expanded', 'true');
      }, OPEN_DELAY);
    });
    megaToggle.addEventListener('click', () => {
      const opening = mega.hidden;
      closeItems();
      mega.hidden = !opening;
      megaToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });

    items.forEach(item => {
      const button = item.querySelector('[data-net-nav-button]');
      const dropdown = item.querySelector('[data-net-nav-dropdown]');
      item.addEventListener('pointerenter', () => openItem(item));
      button?.addEventListener('click', () => {
        if (!dropdown) return;
        if (dropdown.hidden) openItem(item);
        else { dropdown.hidden = true; button.setAttribute('aria-expanded','false'); }
      });
      dropdown?.addEventListener('pointerenter', clearTimers);
      dropdown?.addEventListener('pointerleave', scheduleClose);
    });

    nav.addEventListener('pointerleave', scheduleClose);
    nav.addEventListener('pointerenter', clearTimers);
    mega.addEventListener('pointerenter', clearTimers);
    mega.addEventListener('pointerleave', scheduleClose);

    document.addEventListener('pointerdown', e => {
      if (!header.querySelector('.net-ref-navigation-wrap')?.contains(e.target)) {
        hideMega();
        closeItems();
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        hideMega();
        closeItems();
        megaToggle.focus?.();
      }
    });
    window.addEventListener('resize', () => {
      items.forEach(item => {
        const dd = item.querySelector('[data-net-nav-dropdown]');
        if (dd && !dd.hidden) positionDropdown(item);
      });
    }, { passive: true });
    document.addEventListener('scroll', () => {
      requestAnimationFrame(() => {
        items.forEach(item => {
          const dd = item.querySelector('[data-net-nav-dropdown]');
          if (dd && !dd.hidden) positionDropdown(item);
        });
      });
    }, { passive: true, capture: true });
  }

  function boot(scope = document) { scope.querySelectorAll?.(ROOT).forEach(initMenu); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
